import React, { useState } from "react"; 
import { useTable, useSortBy, usePagination } from "react-table";


const OrderListTable = ({
  data,
  userRole,
  columns,
  pageCount,
  pageIndex,
  pageSize,
  setPageIndex,
  setPageSize,
  totalRecords,
  handleSort,
  sortBy,
  orderBy,
  handleGotoPage,
  errorMessage,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex, pageSize, sortBy: [{ id: sortBy, desc: orderBy === "desc" }] },
      manualPagination: true,
      manualSortBy: true,
      pageCount,
    },
    useSortBy,
    usePagination
  );

  const [inputValue, setInputValue] = useState(pageIndex + 1);
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    const pageNumber = Number(value) - 1;
    if (!isNaN(pageNumber) && pageNumber >= 0 && pageNumber < pageCount) {
      setPageIndex(pageNumber);
    }
  };

  const handlePageChange = (newPageIndex) => {
    if (newPageIndex >= 0 && newPageIndex < pageCount) {
      setPageIndex(newPageIndex);
      gotoPage(newPageIndex);
    }
  };

  return (
    <div>
      {errorMessage && <div className="error">{errorMessage}</div>}
      <table {...getTableProps()} className="dashboardTable">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} className="tableHeader">
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  onClick={() => handleSort(column)}
                >
                  {column.render("Header")}
                  {column.isSorted ? (column.isSortedDesc ? "↓" : "↑") : ""}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {data.length > 0 ? (
            page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  ))}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={columns.length} className="no-data-message">
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="pagination row m-0 mt-3">
        <div className="col-lg-2">
          <button onClick={() => handlePageChange(0)} disabled={!canPreviousPage}>{"<<"}</button>
          <button onClick={() => handlePageChange(pageIndex - 1)} disabled={!canPreviousPage}>{"<"}</button>
          <button onClick={() => handlePageChange(pageIndex + 1)} disabled={!canNextPage}>{">"}</button>
          <button onClick={() => handlePageChange(pageOptions.length - 1)} disabled={!canNextPage}>{">>"}</button>
        </div>
        <div className="col-lg-2">
          <span>Total Records: <strong>{totalRecords}</strong></span>
        </div>
        <div className="col-lg-2">
          <span>Page <strong>{pageIndex + 1} of {pageOptions.length}</strong></span>
        </div>
        <div className="col-lg-3">
          <span>
            Go to page{" "}
            <input
              type="number"
              value={inputValue}
              onChange={handleInputChange}
              onBlur={() => setInputValue(pageIndex + 1)}
              className="gotoPage"
            />
          </span>
        </div>
        <div className="col-lg-3">
          <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))} className="selectDisplayNoOfRecords">
            {[5, 10, 20, 30, 50].map((size) => (
              <option key={size} value={size}>Show {size}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default OrderListTable;